import { render, staticRenderFns } from "./PostMessage.vue?vue&type=template&id=247591c7&scoped=true"
import script from "./PostMessage.vue?vue&type=script&lang=js"
export * from "./PostMessage.vue?vue&type=script&lang=js"
import style0 from "./PostMessage.vue?vue&type=style&index=0&id=247591c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "247591c7",
  null
  
)

export default component.exports